import { Button } from "@mui/material";
import DashCard from "./DashCard";
import ProgressBar from "../../Custom/ProgressBar";
import { useNavigate } from "react-router-dom";
import NoListItems from "../../Custom/NoListItems";

const ExamProgressCard = ({ progressExam }) => {
  const navigate = useNavigate();
  const isNewExam = progressExam?.status === "Start";
  const noExams = progressExam?.link === "/exams";
  const percentage = Math.min(Math.round(progressExam.progress), 100);
  // TODO: NEED TO FIX EXAM IN PROGRESS LINK OPTIONS

  function startExam(e) {
    e.preventDefault();

    navigate(progressExam.link, {
      state: { examId: progressExam.exam_id },
    });
  }

  return (
    <DashCard
      title={`${isNewExam ? "Sugggested Exam" : "Exam Progress"}`}
      cornerContent={
        <Button
          color={`${isNewExam ? "ghostGreen" : "ghostGold"}`}
          className="py-1 px-4"
          variant="contained"
          disableElevation
          onClick={(e) => startExam(e)}
        >
          {progressExam.status}
        </Button>
      }
      children={
        noExams ? (
          <NoListItems text={progressExam.subtitle} />
        ) : (
          <div className="progress-exam-content">
            <>
              <h4 className="child-title">{progressExam.title}</h4>
              <small className="child-subtitle">{progressExam.subtitle}</small>
              {!isNewExam && (
                <ProgressBar percentage={percentage} color="gold" />
              )}
            </>
          </div>
        )
      }
    />
  );
};

export default ExamProgressCard;
